.uni-sidebar {
  position: fixed;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-right: 1px solid #DFE4E9;
  background-color: #FFFFFF;
  z-index: 7;
}
